// extracted by mini-css-extract-plugin
export var modalFooter = "_pa-0";